import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseError, createErrorBuilder } from '@wix/public-editor-platform-errors';
export let EditorPlatformWorkerErrorCode = /*#__PURE__*/function (EditorPlatformWorkerErrorCode) {
  EditorPlatformWorkerErrorCode["WorkerInitError"] = "WorkerInitError";
  EditorPlatformWorkerErrorCode["FrameInitError"] = "FrameInitError";
  return EditorPlatformWorkerErrorCode;
}({});
class EditorPlatformError extends BaseError {
  constructor(message, code) {
    super(message, code, 'Editor Platform Error');
    _defineProperty(this, "state", {});
  }
  withUrl(url) {
    this.state = {
      ...this.state,
      url
    };
    return this;
  }
  withAppDefinitionId(appDefinitionId) {
    this.state = {
      ...this.state,
      appDefinitionId
    };
    return this;
  }
}

/**
 * This error should be thrown only inside worker
 */
export const createEditorPlatformWorkerError = createErrorBuilder(EditorPlatformError);
//# sourceMappingURL=errors.js.map